import { render, staticRenderFns } from "./jy-valueAddedServices.vue?vue&type=template&id=22836df8&scoped=true&"
import script from "./jy-valueAddedServices.vue?vue&type=script&lang=js&"
export * from "./jy-valueAddedServices.vue?vue&type=script&lang=js&"
import style0 from "./jy-valueAddedServices.vue?vue&type=style&index=0&id=22836df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22836df8",
  null
  
)

export default component.exports